export const env = {
  appEnv: import.meta.env.VITE_APP_ENV,
  baseUrl: import.meta.env.VITE_BASE_URL,
  urlPublic: import.meta.env.VITE_URL_PUBLIC,
  siteKeyCloudflare: import.meta.env.VITE_SITE_KEY_CLOUDFLARE,
  urlDoitpayCheckout: import.meta.env.VITE_URL_DOITPAY_CHECKOUT,
  registerEmailMinute: import.meta.env.VITE_REGISTER_EMAIL_MINUTE,
  registerEmailSeconds: import.meta.env.VITE_REGISTER_EMAIL_SECONDS,
  doitpayMerchantIsLive: import.meta.env.VITE_DOITPAY_MERCHANT_ISLIVE,
  sentryDsn: import.meta.env.VITE_SENTRY_DSN,
  notificationTabStatus: import.meta.env.VITE_DOITPAY_STATUS_NOTIFICATION,
};
